var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"live-widget bg-black"},[(_vm.tab && _vm.options)?_c('video-player',{key:_vm.tab,staticClass:"vjs-custom-skin mb-0",attrs:{"options":_vm.options},on:{"ready":_vm.playerReady}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }